/**
 * @generated SignedSource<<56bdd53b4c647cd3483d7df1dd159954>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MusicBackAccessoryType = "DOT" | "NONE" | "%future added value";
export type MusicNoteType = "BAR_NOTE" | "BASS_CLEF" | "DOUBLE_WHOLE_NOTE" | "DOUBLE_WHOLE_REST" | "EIGHT_NOTE" | "EIGHT_REST" | "FLAT" | "HALF_NOTE" | "HALF_REST" | "NATURAL" | "NEGATIVE" | "QUARTER_NOTE" | "QUARTER_REST" | "SHARP" | "SIXTEENTH_NOTE" | "SIXTEENTH_REST" | "TIME_SIGNATURE" | "TREBLE_CLEF" | "WHOLE_NOTE" | "WHOLE_REST" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NoteFinderPageOverlayNote_Note$data = {
  readonly note_id: string;
  readonly x: number;
  readonly y: number;
  readonly height: number;
  readonly width: number;
  readonly finder_confidence: number;
  readonly has_dot: boolean;
  readonly note_types_in_order_of_likelihood_displayable: ReadonlyArray<{
    readonly note_type: MusicNoteType;
    readonly title: string;
    readonly is_audible: boolean;
  }>;
  readonly bar_information: {
    readonly total_number_of_vertical_lines: number;
  } | null;
  readonly bulbs: ReadonlyArray<{
    readonly bulb_id: string;
    readonly x: number;
    readonly y: number;
    readonly width: number;
    readonly height: number;
    readonly median_spacing: number;
    readonly line_placement: number | null;
    readonly bar_information: {
      readonly bar_note_line_idx: number;
      readonly bar_note_number_of_top_lines: number;
    } | null;
    readonly main_lines: ReadonlyArray<{
      readonly a: number;
      readonly b: number;
    }>;
    readonly back_accessory_types_in_order_or_likelihood: ReadonlyArray<MusicBackAccessoryType>;
    readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageOverlayNoteBulb_Bulb">;
  }>;
  readonly " $fragmentType": "NoteFinderPageOverlayNote_Note";
};
export type NoteFinderPageOverlayNote_Note$key = {
  readonly " $data"?: NoteFinderPageOverlayNote_Note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageOverlayNote_Note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "x",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "y",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteFinderPageOverlayNote_Note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note_id",
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finder_confidence",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "has_dot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicParseStepDataNoteDataSourceCombineNoteDisplayable",
      "kind": "LinkedField",
      "name": "note_types_in_order_of_likelihood_displayable",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "note_type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "is_audible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicParseStepDataNoteDataSourceCombineNoteBarInformation",
      "kind": "LinkedField",
      "name": "bar_information",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total_number_of_vertical_lines",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicParseStepDataNoteDataSourceCombineNoteBulb",
      "kind": "LinkedField",
      "name": "bulbs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bulb_id",
          "storageKey": null
        },
        (v0/*: any*/),
        (v1/*: any*/),
        (v3/*: any*/),
        (v2/*: any*/),
        {
          "alias": "median_spacing",
          "args": null,
          "kind": "ScalarField",
          "name": "median_spacing_between_lines",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "line_placement",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MusicParseStepDataNoteDataSourceCombineNoteBulbBarInformation",
          "kind": "LinkedField",
          "name": "bar_information",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bar_note_line_idx",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bar_note_number_of_top_lines",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MusicParseStepDataNoteBulbLineFinderAndPlacerBulbLine",
          "kind": "LinkedField",
          "name": "main_lines",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "a",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "b",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "back_accessory_types_in_order_or_likelihood",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NoteFinderPageOverlayNoteBulb_Bulb"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicParseStepDataNoteDataSourceCombineNote",
  "abstractKey": null
};
})();

(node as any).hash = "96846b1f013daace1b3b3f9036be84d8";

export default node;
